/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { Link } from "found";
import DifficultyRate from "../../Recipe/DifficultyRate";
import StatusButton from "../../StatusButton";
import TrendButton from "../../TrendButton";
import PortionIconNumber from "../../PortionIconNumber";
import { Image } from "semantic-ui-react";
import { ActionsTable } from "ceco-window-table";
import { RecipeModal } from "../../modals/RecipeModal";
import { RecipeDeleteModal } from "../../modals/RecipeDeleteModal";
import { MoreHorizontal, Edit, Delete } from "ceicons";

import DropDownButton from "../../DropDownButton";

import "./recipeTable.scss";

//TODO: Necesito saber donde es mejor hacer el query, si en el router (lo veo mas limpio), o en la misma pagina pero tengo dudas a la hora de pasarle filtros a la query y el paginado.
//TODO: Aqui estoy haciendo una query solo de las recetas.
export default function RecipesTable(props) {
  const {
    allCategories,
    allLabel,
    totalCount,
    recipesParsed,
    refetchData,
    handleScroll,
    filters,
  } = props;

  const t = useTranslation();

  const columnsTable = [
    {
      key: "id",
      basis: 1,
      width: 100,
      ItemRenderer: (
        <TrendCell reload={filters.isTrend} refetchData={refetchData} />
      ),
    },
    {
      key: "id",
      basis: 1,
      width: 100,
      ItemRenderer: PictureCell,
    },
    {
      key: "name",
      width: 250,
      basis: 1,
      title: t("table-header.name"),
      ItemRenderer: NameCell,
    },

    {
      key: "categoryName",
      basis: 1,
      title: t("table-header.category"),
      width: 150,
    },
    {
      key: "difficulty",
      basis: 1,
      title: t("table-header.difficulty"),
      width: 150,
      align: "center",
      ItemRenderer: Difficulty,
    },
    {
      key: "portion",
      basis: 1,
      title: t("table-header.portion"),
      width: 100,
      align: "center",
      ItemRenderer: Portion,
    },
    {
      width: 200,
      key: "state",
      basis: 1,
      title: t("table-header.state"),
      align: "center",
      ItemRenderer: <StatusCell refetchData={refetchData} />,
    },

    {
      style: { minWidth: 50 },
      ItemRenderer: (
        <EditCell
          refetchData={refetchData}
          allCategories={allCategories}
          allLabel={allLabel}
        />
      ),
    },
  ];

  return (
    <ActionsTable
      actions={[]}
      footer={
        <div>
          <div className="legend" />
        </div>
      }
      allowAllItemsSelection={false}
      gridActions={[
        <div className="right floated" key="right-side">
          <strong>
            {totalCount} {t("count.recipes")}
          </strong>
        </div>,
      ]}
      items={recipesParsed}
      columns={columnsTable}
      flags={recipesParsed}
      onScrollTable={handleScroll}
    />
  );
}

const NameCell = (props) => {
  const { data, rowIndex, style } = props;
  const { flags } = data;
  const { id, name } = flags[rowIndex];

  return (
    <div
      role="cell"
      className="cell"
      style={{
        ...style,
        flexGrow: 1,
        padding: "1em",
        border: "",
      }}
    >
      <Link
        style={{ wordBreak: "break-word" }}
        key={id}
        to={`/recipe/${id}`}
        className="recipe-link"
      >
        {name}
      </Link>
    </div>
  );
};

const StatusCell = (props) => {
  const { data, rowIndex, style, refetchData } = props;
  const { flags } = data;
  const { id, published } = flags[rowIndex];

  return (
    <div
      role="cell"
      style={{ ...style, flexGrow: 1, padding: "1em", border: "" }}
      className="status cell"
    >
      <StatusButton
        idRecipe={id}
        status={published}
        refetchData={refetchData}
      />
    </div>
  );
};
const TrendCell = (props) => {
  const { data, rowIndex, style, reload, refetchData } = props;
  const { flags } = data;
  const { isTrend, id, name } = flags[rowIndex];
  return (
    <div
      role="cell"
      style={{ ...style, flexGrow: 1, padding: "1em", border: "" }}
      className="fav cell"
    >
      <TrendButton
        recipeId={id}
        trend={isTrend}
        recipeName={name}
        reload={reload}
        refetchData={refetchData}
      />
    </div>
  );
};

const EditCell = (props) => {
  const { data, rowIndex, style, allCategories, allLabel, refetchData } = props;
  const { flags } = data;
  const { id, name, category } = flags[rowIndex];
  const t = useTranslation();

  return (
    <div
      role="cell"
      style={{ ...style, flexGrow: 1, padding: "1em", border: "" }}
      className="users cell"
    >
      <DropDownButton icon={<MoreHorizontal />}>
        <RecipeModal
          edit
          recipe={{ ...flags[rowIndex], category: category.id }}
          allLabel={allLabel}
          allCategories={allCategories}
          refetchData={refetchData}
          trigger={
            <div>
              <Edit />
              <p>{t("popup.edit")}</p>
            </div>
          }
        />

        <RecipeDeleteModal
          recipeId={id}
          recipeName={name}
          refetchData={refetchData}
          trigger={
            <div className="delete-modal">
              <Delete />
              <p>{t("popup.remove")}</p>
            </div>
          }
          icon={Edit}
        />
      </DropDownButton>
    </div>
  );
};
const Difficulty = (props) => {
  const { data, rowIndex, style } = props;
  const { flags } = data;
  const { difficulty, totalRatings } = flags[rowIndex];

  return (
    <div
      role="cell"
      style={{ ...style, flexGrow: 1, padding: "1em", border: "" }}
      className="users cell"
    >
      <DifficultyRate difficulty={difficulty} number={totalRatings} />
    </div>
  );
};
const Portion = (props) => {
  const { data, rowIndex, style } = props;
  const { flags } = data;
  const { serves } = flags[rowIndex];
  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        padding: "1em",
        border: "",
        justifyContent: "center",
      }}
      className="users cell"
    >
      <PortionIconNumber portion={serves} />
    </div>
  );
};
const PictureCell = (props) => {
  const { data, rowIndex, style } = props;
  const { flags } = data;

  const { mediaFiles } = flags[rowIndex];

  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        padding: "1em",
        border: "",
      }}
      className="cell"
    >
      <Image src={mediaFiles?.edges[0]?.node?.mediaUrl} avatar />
    </div>
  );
};
